module.exports = __webpack_public_path__ + "static/media/wxz.aa70d7c6.svg";